import { SessionCategoryTranslationDto } from "../../dto/sessions/session-category-translations.dto";
import { SessionCategoryTranslation } from "../../models/sessions/session-category.model";

export class SessionCategoryTranslationMapper {
  public static toModel(dto: SessionCategoryTranslationDto): SessionCategoryTranslation {
    return {
      languageId: dto.language_id,
      title: dto.title,
      description: dto.description
    }
  }

  public static toDto(t: SessionCategoryTranslation): SessionCategoryTranslationDto {
    return {
      language_id: t.languageId,
      title: t.title,
      description: t.description
    }
  }
}